import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { EPublishOfferErrorCode } from '../../redux/reducers';
import { IPublishOfferRequest } from '../../repositories/monolith-python/v2/publish-offer';

export interface IPublishOfferParams {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: IPublishOfferRequest;
  /** GET-параметры запроса */
  query?: string;
  subdomain?: string;
}

export type TPublishOfferResult = IPublishOfferSuccess | IPublishOfferFail;

export interface IPublishOfferSuccess {
  success: true;
  payload: IPublishOfferSuccessPayload;
}

export interface IPublishOfferFail {
  success: false;
  statusCode: number;
  payload: IPublishOfferFailPayload;
}

export interface IPublishOfferSuccessPayload {
  /** Ошибки (скорее всего "Видимые нарушения") */
  errors?: IPublishOfferErrors;
  /** RealtyOfferID опубликованного/сохранённого объявления */
  id: number;
  /** URL для редиректа после публикации */
  redirectUrl: string | null;
  /** Статус публикации */
  status: EPublishOfferStatus;
}

export enum EPublishOfferStatus {
  /** Ожидает публикации */
  waitForPublish = 'waitForPublish',
  /** Успешно опубликовано */
  success = 'success',
  /** Требуется идентификация */
  userIdentificationRequired = 'userIdentificationRequired',
  /** Идентификация в процессе */
  userIdentificationInProgress = 'userIdentificationInProgress',
}

export interface IPublishOfferFailPayload {
  /** Код ошибки */
  errorCode: EPublishOfferErrorCode;
  /** Ошибки конкретных полей (ключ объекта — имя поля, значение — текст ошибки) */
  errors: IPublishOfferErrors | null;
  /** Общая ошибка */
  errorMessage: string | null;
}

export interface IPublishOfferErrors {
  /** Список ошибок полей формы */
  [key: string]: Array<IPublishOfferError>;
}
export interface IPublishOfferError {
  /** Текст ошибки */
  message: string;
  /** Код валидации. Например, required */
  code: string;
}
